export default [
  {
    path: '/apps/familia-material/list',
    name: 'apps-familia-material-list',
    component: () => import('@/views/cadastros-gerais/familia-material/list/Index.vue'),
    meta: {
      pageTitle: 'Família Material',
      action: 'read',
      resource: 'FamiliaMaterial',
    },
  },
  // {
  //     path: '/apps/familia-material/edit/:id',
  //     name: 'apps-familia-material-edit',
  //     component: () => import('@/views/cadastros-gerais/familia-material/familia-material-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
